import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import { Widget } from "../../database"

/**
 * Model description here for TypeScript hints.
 */
const WidgetStoreProps = {
  ...BaseModelStoreProps,
  widgets: types.optional(types.array(types.frozen()),[]),
}
export const WidgetStoreModel = types
  .model("WidgetStore")
  .props(WidgetStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof WidgetStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init(){
      self.initModel();
    },
    async getWidgets() {
      this.set('loading', true);
      const models = await Widget.fetch({
        page: 1,
        per_page: 100
      }).catch((e) => {
        console.warn(e)
        this.set('error', e);
        self.rootStore.appStore.set("isOffline", true)
        return []
      }).then((models) => {
        return models.map((model) => model.toArray())
      }).finally(() => this.set('loading', false))

      this.set("widgets", models)
      return models
    }
  }))

type WidgetStoreType = Instance<typeof WidgetStoreModel>
export interface WidgetStore extends WidgetStoreType {}
type WidgetStoreSnapshotType = SnapshotOut<typeof WidgetStoreModel>
export interface WidgetStoreSnapshot extends WidgetStoreSnapshotType {}
export const createWidgetStoreDefaultModel = () => types.optional(WidgetStoreModel, {})
